import { gql } from '@apollo/client';

export const updateConfigSettingsMutation = gql`mutation updateConfigSettings(
  $deepLinkBundleId: String
  $smtpHost: String
  $smtpPort: String
  $smptEmail: String
  $smtpSender: String
  $smtpSenderEmail: String
  $smtpPassWord: String
  $twillioAccountSid: String
  $twillioAuthToken: String
  $twillioPhone: String
  $phoneNumberStatus: Int
  $maxUploadSize: String
  $facebookAppId: String
  $facebookSecretId: String
  $googleClientId: String
  $googleSecretId: String
  $deepLinkContent: String
  $fcmPushNotificationKey: String
  $androidAppMapAPIkey: String
  $iosAppMapAPIkey: String
  $reCaptchaStatus: String
  $reCaptchaV2: String
  $reCaptchaV3: String
  $v2Sitekey: String
  $v3Sitekey: String
  $googleMapBrowserApiKey: String
  $googleMapServerApiKey: String
  $openAiBaseUrl: String
  $openAiKey: String
  $aiTextGeneration: String
  $renterContactMessage: String
  $renterBookingRequest: String
  $aiRenterAccess: String
  $aiAccessCarTitleDescription: String
  $aiAccessCarMarketPricing: String
  $aiOwnerAccess: String
  $autoClaimPayout: String
  $autoPayout: String
  $isPromoCodeEnabled: String
  $isServicePlanEnabled: String
) {
  updateConfigSettings(
    deepLinkBundleId: $deepLinkBundleId
    smtpHost: $smtpHost
    smtpPort: $smtpPort
    smptEmail: $smptEmail
    smtpSender: $smtpSender
    smtpSenderEmail: $smtpSenderEmail
    smtpPassWord: $smtpPassWord
    twillioAccountSid: $twillioAccountSid
    twillioAuthToken: $twillioAuthToken
    twillioPhone: $twillioPhone
    phoneNumberStatus: $phoneNumberStatus
    maxUploadSize: $maxUploadSize
    facebookAppId: $facebookAppId
    facebookSecretId: $facebookSecretId
    googleClientId: $googleClientId
    googleSecretId: $googleSecretId
    deepLinkContent: $deepLinkContent
    fcmPushNotificationKey: $fcmPushNotificationKey
    androidAppMapAPIkey: $androidAppMapAPIkey
    iosAppMapAPIkey: $iosAppMapAPIkey
    reCaptchaStatus: $reCaptchaStatus
    reCaptchaV2: $reCaptchaV2
    reCaptchaV3: $reCaptchaV3
    v2Sitekey: $v2Sitekey
    v3Sitekey: $v3Sitekey
    googleMapBrowserApiKey: $googleMapBrowserApiKey
    googleMapServerApiKey: $googleMapServerApiKey
    openAiBaseUrl: $openAiBaseUrl
    openAiKey: $openAiKey
    aiTextGeneration: $aiTextGeneration
    renterContactMessage: $renterContactMessage
    renterBookingRequest: $renterBookingRequest
    aiRenterAccess: $aiRenterAccess
    aiAccessCarTitleDescription: $aiAccessCarTitleDescription
    aiAccessCarMarketPricing: $aiAccessCarMarketPricing
    aiOwnerAccess: $aiOwnerAccess
    autoClaimPayout:$autoClaimPayout
    autoPayout:$autoPayout
    isPromoCodeEnabled:$isPromoCodeEnabled
    isServicePlanEnabled:$isServicePlanEnabled
  ) {
    status
    errorMessage
  }
}
`;

export const makeModelCsvUploaderMutation = gql`mutation makeModelCsvUploader($csvValue: [[String]]!) {
     makeModelCsvUploader(csvValue: $csvValue) {
       status
       errorMessage
       result {
         duplicateDatas
         isUploadedCsv
         make
         model
       }
     }
   }`

export const siteSettings = gql`
    query ($type: String) {
      siteSettings(type: $type) {
        name
        value
      }
    }
    `;

export const content = `
    query($path:String!,$locale:String!) {
      content(path:$path,locale:$locale) {
        title, content,
      }
    }
    `;

export const updateSettingsData = gql`mutation updateSpecificSiteSettings(
      $fieldName: String,
      $value: String,
      ) {
          updateSpecificSiteSettings(
              fieldName: $fieldName
              value: $value
          ){
              status
          }
      }`;
